import React from 'react';
import { View, Text } from 'react-native';

import { machineStatusColorName } from './functions';

import NotProductiveTile from './notProductiveTile';
import ActiveTile from './activeTile';

import ItemLine from './itemLine';
import { WALLBOARD_TILE_LAYOUT } from '@components/wallboard/constants';
import useManageItem from '@components/wallboard/hooks/useManageItem';

const Item = (props) => {
  const {
    config,
    C,
    scale,
    font,
    isLastLine,
    isLastInLine,
    wallboardSelectedLevel,
  } = props;

  const {
    url,
    batch,
    firstScheduledJob,
    oeeValue,
    machineActive,
    isActiveMachineStatus,
    itemBackgroundColor,
    tourIds,
    tileWebProps,
    headerWebProps,
    machineId,
    shortName,
    machineStatus,
    oldMachineStatusDate,
    oldMachineStatus,
    productionBatchId,
  } = useManageItem(props);

  if (wallboardSelectedLevel !== 'live') {
    return <ItemLine {...props} />;
  }

  const { tileHeight, tileWidth } = config;

  return (
    <View
      style={{
        height: tileHeight,
        width: tileWidth,
        backgroundColor: C(itemBackgroundColor),
        borderRadius: scale(12),
        marginBottom: isLastLine ? 0 : 12,
        marginRight: isLastInLine ? 0 : 12,
        borderColor: C('Wallboard/Light/Tile Hairline'),
        borderWidth: 1,
      }}
      key={machineId + '-' + props.index}
      {...tileWebProps}
    >
      <View
        style={{
          width: tileWidth,
          height: WALLBOARD_TILE_LAYOUT.GAUGE_ROW_HEIGHT_PERCENT,
          backgroundColor: C(machineStatusColorName[machineStatus.status]),
          borderTopLeftRadius: scale(12),
          borderTopRightRadius: scale(12),
          justifyContent: 'center',
          alignContent: 'center',
          marginLeft: -1,
          marginTop: -1,
        }}
        {...headerWebProps}
      >
        <Text
          style={[
            font['Title 2'],
            {
              color: C(machineActive ? 'Label/Light/AlwaysLight Primary' : 'Label/Light/AlwaysLight Secondary'),
              textAlign: 'center',
              fontSize: scale(20),
              lineHeight: scale(26),
              fontWeight: '700',
            },
          ]}
          numberOfLines={1}
          ellipsizeMode="middle"
        >
          {shortName}
        </Text>
      </View>
      {machineActive ? (
        <ActiveTile
          {...{
            ...props,
            oldMachineStatusDate,
            oldMachineStatus,
            firstScheduledJob,
            productionBatchId,
            machineStatus,
            C,
            tileHeight,
            url,
            scaleFactor: config.scaleFactor,
            batch,
            tileWidth,
            tourIds,
            oeeValue,
          }}
        />
      ) : (
        <NotProductiveTile
          {...{
            ...props,
            tileHeight,
            machineStatus,
            scale,
            tileWidth,
            machineId,
            oeeValue,
          }}
        />
      )}
    </View>
  );
};

export default Item;
